/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./keyapis_bell_common_v1.pb"

/**
 * Сервис реализует функционал управления уведомлениями
 */

/**
 * Сервис уведомлений
 */
export class NotificationServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения уведомления.
   * Поддерживает только создание.
   * Метод доступен для: service
   */
  PostNotification = (req: PostNotificationRequestDto, init?: RequestInit): Promise<PostNotificationResponseDto> => {
    return fm.request<PostNotificationRequestDto, PostNotificationResponseDto>(`${this.host}/bell/api/v1/notification`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения уведомления.
   * Метод доступен для: admin, manager, master, slave, service
   */
  GetNotification = (req: GetNotificationRequestDto, init?: RequestInit): Promise<GetNotificationResponseDto> => {
    return fm.request<GetNotificationRequestDto, GetNotificationResponseDto>(`${this.host}/bell/api/v1/notification/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка уведомлений.
   * Метод доступен для: admin, manager, master, slave, service
   */
  GetNotificationList = (req?: GetNotificationListRequestDto, init?: RequestInit): Promise<GetNotificationListResponseDto[]> => {
    return fm.list<GetNotificationListRequestDto, GetNotificationListResponseDto>(`${this.host}/bell/api/v1/notification/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества уведомлений.
   * Метод доступен для: admin, manager, master, slave, service
   */
  GetNotificationCount = (req?: GetNotificationCountRequestDto, init?: RequestInit): Promise<GetNotificationCountResponseDto> => {
    return fm.request<GetNotificationCountRequestDto, GetNotificationCountResponseDto>(`${this.host}/bell/api/v1/notification/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод изменения статуса уведомления на \"Просмотрено\".
   * Метод доступен для: master, slave, service
   */
  PostNotificationView = (req: PostNotificationViewRequestDto, init?: RequestInit): Promise<PostNotificationViewResponseDto> => {
    return fm.request<PostNotificationViewRequestDto, PostNotificationViewResponseDto>(`${this.host}/bell/api/v1/notification/${encodeURIComponent(req.id)}/view`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод изменения статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры.
   * Метод доступен для: master, slave, service
   */
  PostNotificationViewOrponRoomNumber = (req: PostNotificationViewOrponRoomNumberRequestDto, init?: RequestInit): Promise<PostNotificationViewOrponRoomNumberResponseDto> => {
    return fm.request<PostNotificationViewOrponRoomNumberRequestDto, PostNotificationViewOrponRoomNumberResponseDto>(`${this.host}/bell/api/v1/notification/view/orpon/${encodeURIComponent(req.orpon)}/room_number/${encodeURIComponent(req.roomNumber)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Статус
 */
export enum NotificationStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Новый.
   * Устанавливается по умолчанию
   */
  NEW = "NEW",
  /**
   * Доставлен
   */
  DELIVERED = "DELIVERED",
  /**
   * Просмотрен
   */
  VIEWED = "VIEWED",
}
/**
 * Статус
 */
export type NotificationStatusTypeResponseEnum = keyof typeof NotificationStatusType
/**
 * Статус
 */
export type NotificationStatusTypeRequestEnum = Exclude<NotificationStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum NotificationPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type NotificationPagingDirectionTypeResponseEnum = keyof typeof NotificationPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type NotificationPagingDirectionTypeRequestEnum = Exclude<NotificationPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum NotificationPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По дате последнего изменения статуса
   */
  STATUS_CHANGED_AT = "STATUS_CHANGED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type NotificationPagingOrderByTypeResponseEnum = keyof typeof NotificationPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type NotificationPagingOrderByTypeRequestEnum = Exclude<NotificationPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества уведомлений
 */
export type GetNotificationCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: NotificationFilterRequestDto | null
}
/**
 * Ответ на запрос на получение количества уведомлений
 */
export type GetNotificationCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество уведомлений
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetNotificationCountResponseErrorDto
}>
/**
 * Ошибка запроса на получение количества уведомлений
 */
export type GetNotificationCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение количества уведомлений
 */
export type GetNotificationCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка уведомлений
 */
export type GetNotificationListRequestDto = {
  /**
   * Фильтр
   */
  filter?: NotificationFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: NotificationPagingRequestDto
}>
/**
 * Ответ на запрос на получение списка уведомлений
 */
export type GetNotificationListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Уведомление
   */
  readonly data: NotificationResponseDto
  /**
   * Ошибка
   */
  readonly error: GetNotificationListResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка уведомлений
 */
export type GetNotificationListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка уведомлений
 */
export type GetNotificationListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения уведомления
 */
export type GetNotificationRequestDto = {
  /**
   * Идентификатор уведомления.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос на получение уведомления
 */
export type GetNotificationResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Уведомление
   */
  readonly data: NotificationResponseDto
  /**
   * Ошибка
   */
  readonly error: GetNotificationResponseErrorDto
}>
/**
 * Ошибка запроса на получение уведомления
 */
export type GetNotificationResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение уведомления
 */
export type GetNotificationResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Уведомление.
 * # Описание модели
 */
export type NotificationRequestDto = {
  /**
   * Идентификатор.
   * Создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * ОРПОН.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Наименование приложения-отправителя.
   * # Диапазон: 3..256
   */
  appTitle?: string | null
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Заголовок.
   * # Диапазон: 3..128
   */
  header: string
  /**
   * Тело.
   * # Диапазон: 3..256
   */
  text: string
  /**
   * Полезная нагрузка
   */
  payload?: {[key:string]:string}
}
/**
 * Уведомление.
 * # Описание модели
 */
export type NotificationResponseDto = {
  /**
   * Идентификатор.
   * Создаётся сервером.
   * # Тип: Guid
   */
  readonly id: string
  /**
   * ОРПОН.
   * # Диапазон 1..9223372036854775807
   */
  orpon: string
  /**
   * Наименование приложения-отправителя.
   * # Диапазон: 3..256
   */
  appTitle: string | null
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
  /**
   * Заголовок.
   * # Диапазон: 3..128
   */
  header: string
  /**
   * Тело.
   * # Диапазон: 3..256
   */
  text: string
  /**
   * Статус
   */
  readonly statusType: NotificationStatusTypeResponseEnum
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения статуса.
   * Заполняется и обновляется сервером.
   * # Тип: DateTime
   */
  readonly statusChangedAt: string | null
  /**
   * Полезная нагрузка
   */
  payload: {[key:string]:string}
}
/**
 * Фильтр уведомлений
 */
export type NotificationFilterRequestDto = {
  /**
   * По ОРПОН
   */
  orpons?: string[]
  /**
   * По номерам квартир
   */
  roomNumbers?: string[]
  /**
   * По статусам
   */
  statusTypes?: NotificationStatusTypeResponseEnum[]
}
/**
 * Фильтр уведомлений
 */
export type NotificationFilterResponseDto = {
  /**
   * По ОРПОН
   */
  orpons: string[]
  /**
   * По номерам квартир
   */
  roomNumbers: string[]
  /**
   * По статусам
   */
  statusTypes: NotificationStatusTypeResponseEnum[]
}
/**
 * Постраничный вывод
 */
export type NotificationPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType?: NotificationPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: NotificationPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type NotificationPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType: NotificationPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: NotificationPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос сохранения уведомления
 */
export type PostNotificationRequestDto = {
  /**
   * Уведомление
   */
  data: NotificationRequestDto
}
/**
 * Ответ на запрос сохранения уведомления
 */
export type PostNotificationResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Уведомление
   */
  readonly data: NotificationResponseDto
  /**
   * Ошибка
   */
  readonly error: PostNotificationResponseErrorDto
}>
/**
 * Ошибка сохранения уведомления
 */
export type PostNotificationResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка сохранения уведомления
 */
export type PostNotificationResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры
 */
export type PostNotificationViewOrponRoomNumberRequestDto = {
  /**
   * ОРПОН.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Ответ на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры
 */
export type PostNotificationViewOrponRoomNumberResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество изменённых уведомлений
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: PostNotificationViewOrponRoomNumberResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostNotificationViewOrponRoomNumberResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostNotificationViewOrponRoomNumberResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос на изменение статуса уведомления на \"Просмотрено\" уведомления
 */
export type PostNotificationViewRequestDto = {
  /**
   * Идентификатор уведомления.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на изменение статуса уведомления на \"Просмотрено\" уведомления
 */
export type PostNotificationViewResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostNotificationViewResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostNotificationViewResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostNotificationViewResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества уведомлений
   */
  "GetNotificationCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества уведомлений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "NotificationFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос на получение количества уведомлений
   */
  "GetNotificationCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение количества уведомлений",
    "fields": {
      /**
       * Количество уведомлений
       */
      "data": {
        "type": "int32",
        "text": "Количество уведомлений",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение количества уведомлений
   */
  "GetNotificationCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение количества уведомлений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка уведомлений
   */
  "GetNotificationListRequest": {
    "kind": "class",
    "text": "Запрос получения списка уведомлений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "NotificationFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "NotificationPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос на получение списка уведомлений
   */
  "GetNotificationListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка уведомлений",
    "fields": {
      /**
       * Уведомление
       */
      "data": {
        "type": "Notification",
        "text": "Уведомление",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка уведомлений
   */
  "GetNotificationListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка уведомлений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения уведомления
   */
  "GetNotificationRequest": {
    "kind": "class",
    "text": "Запрос получения уведомления",
    "fields": {
      /**
       * Идентификатор уведомления.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор уведомления.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение уведомления
   */
  "GetNotificationResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение уведомления",
    "fields": {
      /**
       * Уведомление
       */
      "data": {
        "type": "Notification",
        "text": "Уведомление",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение уведомления
   */
  "GetNotificationResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Уведомление.
   * # Описание модели
   */
  "Notification": {
    "kind": "class",
    "text": "Уведомление.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nСоздаётся сервером.\n# Тип: Guid",
      },
      /**
       * ОРПОН.
       * # Диапазон 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\n# Диапазон 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Наименование приложения-отправителя.
       * # Диапазон: 3..256
       */
      "appTitle": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование приложения-отправителя.\n# Диапазон: 3..256",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
      /**
       * Заголовок.
       * # Диапазон: 3..128
       */
      "header": {
        "type": "string",
        "text": "Заголовок.\n# Диапазон: 3..128",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
      /**
       * Тело.
       * # Диапазон: 3..256
       */
      "text": {
        "type": "string",
        "text": "Тело.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Статус
       */
      "statusType": {
        "type": "Notification.StatusType",
        "text": "Статус",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения статуса.
       * Заполняется и обновляется сервером.
       * # Тип: DateTime
       */
      "statusChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения статуса.\nЗаполняется и обновляется сервером.\n# Тип: DateTime",
      },
      /**
       * Полезная нагрузка
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Полезная нагрузка",
      },
    },
  },
  /**
   * Фильтр уведомлений
   */
  "NotificationFilter": {
    "kind": "class",
    "text": "Фильтр уведомлений",
    "fields": {
      /**
       * По ОРПОН
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОН",
      },
      /**
       * По номерам квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
      /**
       * По статусам
       */
      "statusTypes": {
        "type": "Notification.StatusType",
        "text": "По статусам",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "NotificationPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CREATED_AT
       */
      "orderByType": {
        "type": "NotificationPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CREATED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "NotificationPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос сохранения уведомления
   */
  "PostNotificationRequest": {
    "kind": "class",
    "text": "Запрос сохранения уведомления",
    "fields": {
      /**
       * Уведомление
       */
      "data": {
        "type": "Notification",
        "text": "Уведомление",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения уведомления
   */
  "PostNotificationResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения уведомления",
    "fields": {
      /**
       * Уведомление
       */
      "data": {
        "type": "Notification",
        "text": "Уведомление",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostNotificationResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка сохранения уведомления
   */
  "PostNotificationResponse.Error": {
    "kind": "class",
    "text": "Ошибка сохранения уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры
   */
  "PostNotificationViewOrponRoomNumberRequest": {
    "kind": "class",
    "text": "Запрос на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры",
    "fields": {
      /**
       * ОРПОН.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
    },
  },
  /**
   * Ответ на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры
   */
  "PostNotificationViewOrponRoomNumberResponse": {
    "kind": "class",
    "text": "Ответ на изменение статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры",
    "fields": {
      /**
       * Количество изменённых уведомлений
       */
      "data": {
        "type": "int32",
        "text": "Количество изменённых уведомлений",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostNotificationViewOrponRoomNumberResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostNotificationViewOrponRoomNumberResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на изменение статуса уведомления на \"Просмотрено\" уведомления
   */
  "PostNotificationViewRequest": {
    "kind": "class",
    "text": "Запрос на изменение статуса уведомления на \"Просмотрено\" уведомления",
    "fields": {
      /**
       * Идентификатор уведомления.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор уведомления.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на изменение статуса уведомления на \"Просмотрено\" уведомления
   */
  "PostNotificationViewResponse": {
    "kind": "class",
    "text": "Ответ на изменение статуса уведомления на \"Просмотрено\" уведомления",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostNotificationViewResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostNotificationViewResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Статус
   */
  "Notification.StatusType": {
    "kind": "enum",
    "text": "Статус",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Новый.
       * Устанавливается по умолчанию
       */
      "NEW": {
        "i": 1,
        "text": "Новый.\nУстанавливается по умолчанию",
      },
      /**
       * Доставлен
       */
      "DELIVERED": {
        "i": 2,
        "text": "Доставлен",
      },
      /**
       * Просмотрен
       */
      "VIEWED": {
        "i": 3,
        "text": "Просмотрен",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "NotificationPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "NotificationPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате создания
       */
      "CREATED_AT": {
        "i": 1,
        "text": "По дате создания",
      },
      /**
       * По дате последнего изменения статуса
       */
      "STATUS_CHANGED_AT": {
        "i": 2,
        "text": "По дате последнего изменения статуса",
      },
    },
  },
}